import React from 'react';
import PropTypes from 'prop-types';
import './NotificationBox.css';

const NotificationBox = ({ error, children }) => (
  <div className={`notificationBox ${error && 'notificationBox--error'}`}>{children}</div>
);

NotificationBox.defaultProps = {
  error: false,
  children: undefined,
};

NotificationBox.propTypes = {
  error: PropTypes.bool,
  children: PropTypes.node,
};

export default NotificationBox;
